// extracted by mini-css-extract-plugin
export var container = "_93-0";
export var error = "_93-9";
export var label = "_93-5";
export var light = "_93-6";
export var md = "_93-3";
export var sm = "_93-2";
export var thin = "_93-8";
export var thinBold = "_93-7";
export var vertical = "_93-4";
export var xs = "_93-1";